module.exports = __webpack_public_path__ + "static/media/SouthWesternTimes-devicecomp-min@2x.898815f7.webp";